module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('a', {
    staticClass: "logo pull-left",
    staticStyle: {
      "background-image": "url('static/images/logo-red.png')"
    },
    attrs: {
      "href": "//sh.12348.gov.cn/sites/12348/team.jsp?active=0f4806060c7e4b669ea3f997525cacd7",
      "target": "_blank",
      "title": "上海法治地图"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav pull-left"
  }, [_c('li', [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("法律机构")])])]), _vm._v(" "), _c('ul', {
    staticClass: "subnav pull-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "//sfj.sh.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("上海司法行政网")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "li-spacing"
  })]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//sh.12348.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("12348上海法网")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f42c345"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 103
// module chunks = 1